import { KYMW0001OutputModel } from "src/app/commons/kymw00/kymw0001/vo/kymw0001-output.model";
import { KYMW0002OutputModel } from "src/app/commons/kymw00/kymw0002/vo/kymw0002-output.model";

/**
 * 商品企画マスタ画面　選定候補一覧検索条件VOクラス
 */
export class KYMW1300GetPlanTargetListModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分

  //商品検索ダイアログ　
  public pcode: string = null;                                                  // Ｐコード
  public itemCode: string = null;                                               // アイテムコード
  public janCode: string = null;                                                // ＪＡＮコード
  public makerName: string = null;                                              // メーカー名
  public guideGoodsName: Array<any> = new Array<any>();                         // 商品案内用商品名
  public guideStandardName: Array<any> = new Array<any>();                      // 商品案内用規格名
  public tagSearchType: string = null;                                          // タグ検索方法
  public goodsMarkSearchType: string = null;                                    // 商品マーク検索方法
  public dataKbnFlg: boolean = <boolean>false;                                  // 取扱終了商品を含む
  public goodsDiv: string = null;                                               // ダミー商品
  public buyerCode: string = null;                                              // バイヤーコード
  public admitStatus: string = null;                                            // 登録レベル
  public registDateFrom: string = null;                                         // マスタ登録日(開始)
  public registDateTo: string = null;                                           // マスタ登録日(終了)
  public updateDateFrom: string = null;                                         // マスタ更新日(開始)
  public updateDateTo: string = null;                                           // マスタ更新日(終了)
  public classCode: string = null;                                              // 部門
  public middleClassCode: string = null;                                        // 中分類
  public smallClassCode: string = null;                                         // 小分類
  public ordrClientCode: string = null;                                         // 発注先コード
  public ordrClientKanji: string = null;                                        // 発注先名称
  public payeeClientCode: string = null;                                        // 支払先コード
  public payeeClientKanji: string = null;                                       // 支払先名称
  public duties: Array<any> = new Array<any>();                                 // デイリー
  public searchMediumType: string = null;                                       // 商品検索媒体区分
  public searchOrderCode: string = null;                                        // 商品検索受注コード
  public specialFeature: string = null;                                         // 特集コード
  public catalogCode: Array<any> = new Array<any>();                            // 企画マーク
  public catalogCodeSearchType: string = null;                                  // 企画マーク検索方法
  public pageNo: Array<any> = new Array<any>();                                 // ページNO
  public page: string = <string>'1';                                            // ページ
  public sortItem: string = null;                                               // ソート項目名
  public sortOrder: string = null;                                              // 昇順降順区分
  public tagId: Array<any> = new Array<any>();                                  // タグ
  public goodsMark: Array<any> = new Array<any>();                              // 商品マーク
  public coopCode: Array<any> = new Array<any>();                               // 取扱可能生協
  public pcodeList: Array<any> = new Array<any>();                              // Ｐコードリスト
  public itemCodeList: Array<any> = new Array<any>();                           // アイテムコード
  public bundleCatalogOrderCode: Array<any> = new Array<any>();                 // 束ね企画受注コード
  public tagOutput:KYMW0002OutputModel;                                         // タグ再表示用
  public goodsMarkOutput:KYMW0001OutputModel;                                   // 商品マーク再表示用
  public catalogId: string = <string>'';                                        // 企画回再表示用
  public catalogMarkOutput: KYMW0001OutputModel;                                // 企画マーク再表示用
  public pageInput: string = '';                                                // ページ再表示用
  public searchKbn: number = <number>0;                                         // 検索区分（0:通常検索、1:リスト検索（Pコード）、2:リスト検索（アイテムコード））

  // フォーカスフラグ
  // 0：表示、1：前へボタン(選定済)、2：次へボタン(選定済)
  // 3：表示モード・部門、4：次回案内一括設定、5：次回案内チェック
  public focusFlg: string = null;

  public refleshFlg: string = <string>'0';                                      // 画面再描画フラグ(0：必要、1：不要)

}
